import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const LoadSalesPortalOrderSummary_OrderEntryFeeFieldsFragmentDoc = gql`
  fragment LoadSalesPortalOrderSummary_OrderEntryFeeFields on OrderEntryFee {
    amount_in_micros
    name
  }
`;
export const LoadSalesPortalOrderSummary_OrderEntryOrderFeesFieldsFragmentDoc = gql`
  fragment LoadSalesPortalOrderSummary_OrderEntryOrderFeesFields on OrderEntryOrderFees {
    discount {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    order_promotion_discount {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    promotion_discount {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    subtotal {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    tax {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    tip {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    total {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
    volume_discount {
      ...LoadSalesPortalOrderSummary_OrderEntryFeeFields
    }
  }
  ${LoadSalesPortalOrderSummary_OrderEntryFeeFieldsFragmentDoc}
`;
export const LoadSalesPortalOrderSummary_OrderEntrySplitMetricsFieldsFragmentDoc = gql`
  fragment LoadSalesPortalOrderSummary_OrderEntrySplitMetricsFields on OrderEntrySplitMetrics {
    fulfillment_date
    fulfillment_type
    gross_profit_in_micros
    gross_profit_in_percentage
    item_count
    subtotal_in_micros
    unit_count
  }
`;
export const LoadSalesPortalOrderSummary_OrderEntryCartSummaryFieldsFragmentDoc = gql`
  fragment LoadSalesPortalOrderSummary_OrderEntryCartSummaryFields on OrderEntryCartSummary {
    currency
    order_id
    order_fees {
      ...LoadSalesPortalOrderSummary_OrderEntryOrderFeesFields
    }
    split_order_metrics {
      ...LoadSalesPortalOrderSummary_OrderEntrySplitMetricsFields
    }
  }
  ${LoadSalesPortalOrderSummary_OrderEntryOrderFeesFieldsFragmentDoc}
  ${LoadSalesPortalOrderSummary_OrderEntrySplitMetricsFieldsFragmentDoc}
`;
export const LoadSalesPortalOrderSummaryDocument = gql`
  query LoadSalesPortalOrderSummary(
    $orderIds: [uuid!]!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getOrderEntrySummary(
      order_ids: $orderIds
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      summaries {
        ...LoadSalesPortalOrderSummary_OrderEntryCartSummaryFields
      }
    }
  }
  ${LoadSalesPortalOrderSummary_OrderEntryCartSummaryFieldsFragmentDoc}
`;
export function useLoadSalesPortalOrderSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >(LoadSalesPortalOrderSummaryDocument, options);
}
export function useLoadSalesPortalOrderSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >(LoadSalesPortalOrderSummaryDocument, options);
}
export type LoadSalesPortalOrderSummaryQueryHookResult = ReturnType<
  typeof useLoadSalesPortalOrderSummaryQuery
>;
export type LoadSalesPortalOrderSummaryLazyQueryHookResult = ReturnType<
  typeof useLoadSalesPortalOrderSummaryLazyQuery
>;
export type LoadSalesPortalOrderSummaryQueryResult = Apollo.QueryResult<
  Types.LoadSalesPortalOrderSummaryQuery,
  Types.LoadSalesPortalOrderSummaryQueryVariables
>;

/**
 * Wrapped version of useGeneratedLoadSalesPortalOrderSummaryQuery using Pepper's useWrappedQuery
 */
export function useGeneratedLoadSalesPortalOrderSummaryQuery(
  options?: Apollo.QueryHookOptions<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >(LoadSalesPortalOrderSummaryDocument, options);
}

/**
 * Wrapped version of useGeneratedLoadSalesPortalOrderSummaryLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedLoadSalesPortalOrderSummaryLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.LoadSalesPortalOrderSummaryQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.LoadSalesPortalOrderSummaryQuery,
    Types.LoadSalesPortalOrderSummaryQueryVariables
  >(LoadSalesPortalOrderSummaryDocument, lazyOptions);
}
